import React, { Fragment, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setModalStatus } from "../Actions/LanguageAndCountry.action";
import { status } from "../Actions/Overlay.action";
import { translate } from "../Services/translation";

const NavigationItem = ({ links = [], contentLink = null, level }) => {
    const overlayState = useSelector((state) => state.overlay.status);
    const dispatch = useDispatch();
    const menuRef = useRef(null);

    useEffect(() => {
        if (!overlayState && menuRef.current) {
            menuRef.current.classList.remove("navbar__menu--show");
        }
    }, [overlayState]);

    const toggleMenuMob = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle("navbar__menu--show");
        dispatch(status(true));
    };
    const closeMenuMob = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle("navbar__menu--show");
        dispatch(status(false));
    };
    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle("navbar__menu--show");
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? "navbar__link--selected" : "";
    const hasChildrenClass = links.length > 0 ? "has-children" : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    return (
        <Fragment>
            {!contentLink ? (
                <button
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenuMob}
                    title={translate("general.menu") || "menu"}
                ></button>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ""
                        } ${additionClass || ""}`}
                        href={contentLink.url || "#"}
                    >
                        {contentLink && contentLink.iconUrl && (
                            <img
                                className="navbar__link--icon"
                                src={contentLink.iconUrl}
                            />
                        )}
                        <span
                            dangerouslySetInnerHTML={{
                                __html: contentLink.name,
                            }}
                        ></span>
                        {level === 1 && links.length > 0 && (
                            <i className="navbar__link-more"></i>
                        )}
                    </a>
                    {links.length > 0 && (
                        <button
                            className="navbar__menu-toggle"
                            onClick={toggleMenu}
                        >
                            <i className="navbar__icon--caret-right navbar__icon navbar__icon--open"></i>
                        </button>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <button
                                className="navbar__icon navbar__icon--close"
                                onClick={closeMenuMob}
                            ></button>
                        ) : (
                            <Fragment>
                                <button className="navbar__menu-header-button" onClick={toggleMenu}>
                                    <i className="navbar__icon--caret-left navbar__icon"></i>
                                    <span
                                        className="navbar__title"
                                        dangerouslySetInnerHTML={{
                                            __html: contentLink.name,
                                        }}
                                    ></span>
                                </button>
                            </Fragment>
                        )}
                    </div>
                    <ul className="navbar__menu-links">
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className="navbar__item"
                                            key={index}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                level={level + 1}
                                            />
                                        </li>
                                    )
                            )}
                        {level === 0 && (
                            <li className="navbar__item-secondary">
                                <button
                                    className="navbar__link"
                                    onClick={() =>
                                        dispatch(setModalStatus(true))
                                    }
                                >
                                    <div className="it">
                                        <div className="it__icon">
                                            <i className="icon icon--globe"></i>
                                        </div>
                                        <div className="it__text">
                                            {translate(
                                                "header.language.choose"
                                            )}
                                        </div>
                                    </div>
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
